export const getAvailableStockQty = /* GraphQL */ `
  query GetAvailableStockQty($input: GetAvailableStockQtyInput!) {
    getAvailableStockQty(input: $input) {
      productId
      locationQty {
        location
        qty
      }
    }
  }
`;

export const getCoupon = /* GraphQL */ `
  query GetCoupon($company: ID!, $id: ID!) {
    getCoupon(company: $company, id: $id) {
      company
      id
      description
      type
      status
      expireAt
      startTime
      value
      qtyAvailable
      qtyReserved
      qtyUsed
      minSpend
      maxSpend
      createdAt
      updatedAt
      version
      products {
        items {
          company
          id
          couponId
          productId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;